export default __webpack_public_path__ + "static/media/mail_logo.db7ead50.svg";